import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import './venue-logistics.css';

const {FiCheck,FiClock,FiMapPin,FiShield,FiTruck} = FiIcons;

const logisticsItems=[
  {id: 'loadInInstructions',label: 'Load-in instructions',icon: FiTruck,placeholder: 'Where should the production team enter and unload equipment?'},
  {id: 'venueContact',label: 'Venue contact',icon: FiMapPin,placeholder: 'Name and phone number for the venue contact'},
  {id: 'setupAccessTime',label: 'Setup access time',icon: FiClock,placeholder: 'When can the production team begin setup?'},
  {id: 'parkingAccess',label: 'Parking and vendor access',icon: FiTruck,placeholder: 'Describe parking, loading zones, stairs, elevators or access restrictions'},
  {id: 'powerAccess',label: 'Power access',icon: FiShield,placeholder: 'List available outlets, circuits or power limitations'},
  {id: 'venueRestrictions',label: 'Venue restrictions',icon: FiShield,placeholder: 'Note sound, lighting, haze, flame, confetti or volume restrictions'},
  {id: 'insuranceRequirements',label: 'Insurance requirements',icon: FiShield,placeholder: 'Does the venue require a certificate of insurance or other paperwork?'}
];

function VenueLogisticsChecklist({answers,onChange}) {
  const update=(id,value)=>{
    onChange(id,value);
  };

  return (
    <section className="venue-logistics">
      <div className="venue-logistics-heading">
        <div className="venue-logistics-icon">
          <SafeIcon icon={FiMapPin} />
        </div>
        <div>
          <span className="eyebrow">Production readiness</span>
          <h3>Venue logistics checklist</h3>
          <p>
            Share the practical details our team needs for a smooth load-in,
            setup and event day.
          </p>
        </div>
      </div>

      <div className="venue-logistics-list">
        {logisticsItems.map((item,index)=> {
          const Icon=item.icon;
          return (
            <label className="venue-logistics-item" key={item.id}>
              <span className="venue-logistics-number">
                {answers[item.id] ? <SafeIcon icon={FiCheck} /> : String(index + 1).padStart(2,'0')}
              </span>
              <span className="venue-logistics-copy">
                <span className="venue-logistics-label">
                  <SafeIcon icon={Icon} />
                  {item.label}
                </span>
                <textarea
                  value={answers[item.id] || ''}
                  onChange={(event)=> update(item.id,event.target.value)}
                  placeholder={item.placeholder}
                  rows="2"
                />
              </span>
            </label>
          );
        })}
      </div>
    </section>
  );
}

export default VenueLogisticsChecklist;